import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LiveAuctionPill() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > 800);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href="#all-packages"
          onClick={(e) => { e.preventDefault(); document.getElementById("all-packages")?.scrollIntoView({ behavior: "smooth" }); }}
          initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22,1,0.36,1] }}
          className="fixed bottom-24 md:bottom-6 right-4 md:right-8 z-40 flex items-center gap-3 pl-4 pr-5 py-3 rounded-full shadow-2xl font-bold tracking-[0.2em] uppercase text-[11px] md:text-[12px]"
          style={{
            background: "linear-gradient(90deg,#c8102e 0%,#c9a24b 55%,#4b2e83 100%)",
            color: "#ffffff",
            boxShadow: "0 20px 45px -15px rgba(201,162,75,0.55)",
          }}
          data-testid="live-auction-pill"
        >
          <span className="inline-flex items-center gap-2 rounded-full bg-black/40 px-2 py-1 text-[9px]">
            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"/> Live
          </span>
          <span>Live Auction — View Packages</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
